__turbopack_context__.v({
  "container": "ErrorModal-module-scss-module__EspwoG__container",
  "footer": "ErrorModal-module-scss-module__EspwoG__footer",
  "message": "ErrorModal-module-scss-module__EspwoG__message",
  "title": "ErrorModal-module-scss-module__EspwoG__title",
});
